<div
  class="sidebar-container"
  [ngClass]="sidebarStateService.getSidebarState() ? 'expanded' : 'collapsed'"
>
  <!-- Header / Account name -->
  <div class="sidebar-header" *ngIf="accountDisplayName">
    <a
      class="home-icon-link"
      [routerLink]="'/dashboard'"
      routerLinkActive="active"
    >
      <mat-icon class="home-icon">home</mat-icon>
      <span class="home-label" *ngIf="sidebarStateService.getSidebarState()">
        {{ accountDisplayName }}
      </span>
    </a>
  </div>

  <!-- Search -->
  <div
    class="search-container"
    *ngIf="sidebarStateService.getSidebarState()"
  >
    <div class="custom-search-wrapper">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        class="custom-search-input"
        type="text"
        placeholder="Search menu..."
        [(ngModel)]="searchText"
      />
      <button
        *ngIf="searchText"
        type="button"
        class="clear-button"
        (click)="searchText = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Menu -->
  <div class="sidebar-content custom-scrollbar">
    <nav class="menu-nav">
      <div
        class="menu-item-wrapper"
        *ngFor="let item of menuItems"
      >
        <!-- Parent with route -->
        <a
          #sidebarItemWithRoute
          *ngIf="item.route && !item.children"
          class="menu-item"
          [routerLink]="item.route"
          routerLinkActive="active"
          (click)="onCardClick($event, item.disable, item)"
          (mouseenter)="showCollapsedFlyout(item, sidebarItemWithRoute)"
          (mouseleave)="scheduleHideCollapsedFlyout()"
        >
          <div class="menu-icon">
            <mat-icon>{{ item.iconName }}</mat-icon>
          </div>
          <span class="menu-label" *ngIf="sidebarStateService.getSidebarState()">
            {{ item.label }}
          </span>
        </a>

        <!-- Parent with children (collapsible group) -->
        <a
          #sidebarItemWithChildren
          *ngIf="item.children"
          href="#"
          class="menu-item"
          [class.expanded]="activeParent === item"
          (click)="toggleSubmenu($event, item)"
          (mouseenter)="showCollapsedFlyout(item, sidebarItemWithChildren)"
          (mouseleave)="scheduleHideCollapsedFlyout()"
        >
          <div class="menu-icon">
            <mat-icon>{{ item.iconName }}</mat-icon>
          </div>
          <span class="menu-label" *ngIf="sidebarStateService.getSidebarState()">
            {{ item.label }}
          </span>
          <mat-icon
            class="expand-icon"
            *ngIf="sidebarStateService.getSidebarState()"
            [class.rotated]="activeParent === item"
          >
            expand_more
          </mat-icon>
        </a>

        <!-- Parent with action / no route, no children -->
        <a
          #sidebarItemAction
          *ngIf="!item.route && !item.children"
          href="#"
          class="menu-item"
          (click)="onCardClick($event, item.disable, item)"
          (mouseenter)="showCollapsedFlyout(item, sidebarItemAction)"
          (mouseleave)="scheduleHideCollapsedFlyout()"
        >
          <div class="menu-icon">
            <mat-icon>{{ item.iconName }}</mat-icon>
          </div>
          <span class="menu-label" *ngIf="sidebarStateService.getSidebarState()">
            {{ item.label }}
          </span>
        </a>

        <!-- Submenu items -->
        <div
          class="submenu-container"
          *ngIf="item.children && activeParent === item"
        >
          <a
            class="submenu-item"
            *ngFor="let child of item.children"
            #sidebarItemChild
            [routerLink]="child.route || null"
            routerLinkActive="active"
            (mouseenter)="showCollapsedFlyout(child, sidebarItemChild)"
            (mouseleave)="scheduleHideCollapsedFlyout()"
            (click)="onCardClick($event, child.disable, child)"
            [attr.href]="child.route ? null : '#'"
          >
            {{ child.label }}
          </a>
        </div>
      </div>
    </nav>
  </div>

  <div
    class="hover-popup"
    [class.single-item]="hoveredItem && !hasCollapsedChildren(hoveredItem)"
    *ngIf="hoveredItem && !sidebarStateService.getSidebarState()"
    [style.top]="popupTop !== null ? popupTop + 'px' : null"
    [style.bottom]="popupBottom !== null ? popupBottom + 'px' : null"
    [style.left.px]="popupLeft"
    (mouseenter)="keepCollapsedFlyout()"
    (mouseleave)="hideCollapsedFlyout()"
  >
    <a
      *ngIf="hoveredItem.route && !hasCollapsedChildren(hoveredItem); else popupHeaderBlock"
      class="popup-header popup-header-link"
      [routerLink]="hoveredItem.route"
      routerLinkActive="active"
      (click)="onCollapsedSingleItemClick($event, hoveredItem)"
    >
      <div class="popup-icon-wrap">
        <mat-icon>{{ hoveredItem.iconName }}</mat-icon>
      </div>
      <span class="popup-divider"></span>
      <span class="popup-label">{{ hoveredItem.label }}</span>
    </a>

    <ng-template #popupHeaderBlock>
      <div
        class="popup-header"
        [class.popup-header-action]="!hoveredItem.route && !hasCollapsedChildren(hoveredItem)"
        (click)="!hasCollapsedChildren(hoveredItem) && !hoveredItem.route ? onCollapsedSingleItemClick($event, hoveredItem) : null"
      >
        <div class="popup-icon-wrap">
          <mat-icon>{{ hoveredItem.iconName }}</mat-icon>
        </div>
        <span class="popup-divider" *ngIf="!hasCollapsedChildren(hoveredItem)"></span>
        <span class="popup-label">{{ hoveredItem.label }}</span>
      </div>
    </ng-template>

    <div class="popup-content" *ngIf="hasCollapsedChildren(hoveredItem)">
      <a
        *ngFor="let child of hoveredItem.children"
        class="popup-item"
        [routerLink]="child.route || null"
        routerLinkActive="active"
        [attr.href]="child.route ? null : '#'"
        (click)="onCollapsedFlyoutChildClick($event, child)"
      >
        {{ child.label }}
      </a>
    </div>
  </div>
</div>